import { render, staticRenderFns } from "./EstoqueBI.vue?vue&type=template&id=e9cafedc"
import script from "./EstoqueBI.vue?vue&type=script&lang=js"
export * from "./EstoqueBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports